<div *ngIf="htmlContent" (mouseover)="onHover($event)" (click)="onClick($event)"
     [innerHTML]="htmlContent | sanitizeHtml" style="width: 100vh"></div>
